import React, {Fragment} from "react";
import {Button} from "reactstrap";
import {Link} from "react-router-dom";
import * as QueryStringUtil from "../../../utils/QueryStringUtil";


const CUSTOMER_CARE_NUMBER = process.env.REACT_APP_CUSTOMER_CARE_NUMBER;

export default class PaymentResultPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            result: this.props.match.params.result,
            payatReferenceNum: QueryStringUtil.getQueryStringValue('payatReferenceNum'),
            payatTranId: QueryStringUtil.getQueryStringValue('payatTranId'),
            digiapiPaymentMethod: QueryStringUtil.getQueryStringValue('digiapiPaymentMethod'),
            digiapiResponseMsg: QueryStringUtil.getQueryStringValue('digiapiResponseMsg'),
            digiapiExternalRef: QueryStringUtil.getQueryStringValue('digiapiExternalRef')
        }
    }

    render() {
        return <Fragment>
            <div style={
                {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }
            }>
                {this.renderMessage()}
                <Link to={"/transactions"}>
                    <Button color="primary">OK</Button>
                </Link>
            </div>
        </Fragment>
    }

    renderMessage() {
        switch (this.props.match.params.result) {
            case 'success': {
                return this.renderSuccess()
            }
            case 'failed': {
                return this.renderFailed()
            }
            case 'canceled': {
                return this.renderCanceled()
            }
            default : {
                return this.renderDefault()
            }
        }
    }

    renderSuccess() {
        return <Fragment>
            <i className="fa fa-check-circle fa-3x text-success" aria-hidden="true"/>&nbsp;&nbsp;
            <span style={{
                textAlign: "center"
            }}>
                <p>
                    Payment was successful for payment reference {this.state.payatReferenceNum}.
                </p>
            </span>
        </Fragment>;
    }

    renderFailed() {
        return <Fragment>
            <i className="fa fa-times-circle fa-3x text-danger" aria-hidden="true"/>&nbsp;&nbsp;
            <span style={{
                textAlign: "center"
            }}
            >
                <p>
                    Failed to complete payment for reference {this.state.payatReferenceNum}.
                </p>
                <p>
                    Please retry the payment or contact our customer service on {CUSTOMER_CARE_NUMBER}.
                </p>
                <p>
                    Reason : {this.state.digiapiResponseMsg}
                </p>
            </span>
        </Fragment>
    }

    renderCanceled() {
        return <Fragment>
            <i className="fa fa-times-circle fa-3x text-danger" aria-hidden="true"/>&nbsp;&nbsp;
            <span style={{
                textAlign: "center"
            }}>
                <p>
                    Payment was canceled for reference {this.state.payatReferenceNum}.
                </p>
            </span>
        </Fragment>
    }

    renderDefault() {
        return <Fragment>
            Unsure what happened
        </Fragment>;
    }
}